import React from "react";
import styles from "../components/laymanComp_css/LaymanPage17.module.css";
import Common_html from "./Common_html";
import BlockData from "../../../layman-explanation-json/eiShaddai.json";
export default function LaymanPage17() {
  return (
    <>
    <Common_html BlockData={BlockData} />
    </>
  );
}
